import { render, staticRenderFns } from "./Markets.vue?vue&type=template&id=eccda46c&scoped=true&"
import script from "./Markets.vue?vue&type=script&lang=js&"
export * from "./Markets.vue?vue&type=script&lang=js&"
import style0 from "./Markets.vue?vue&type=style&index=0&id=eccda46c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eccda46c",
  null
  
)

export default component.exports